import tokens from '@fcc/tokens/dist/tokens.json';

export const DEFAULT_THEME = {
    drawer: {
        window: {
            custom: {
                'max-width': '460px',
            },
        },
    },
    input: {
        wrapper: {
            base: {
                'background-color': tokens.color.primary.seattle.c05,
                transition: 'all .2s',
                'border-radius': '8px',
                border: `1px solid ${tokens.color.primary.seattle.c05}`,
                width: '100%',
                'padding-left': '12px',
                'padding-right': '12px',
            },
            design: {
                outline: {
                    border: `1px solid ${tokens.color.primary.seattle.c05}`,
                },
            },
            hover: {
                outline: {
                    'border-color': tokens.color.primary.seattle.c140,
                },
            },
            invalid: {
                outline: {
                    'border-color': '#FF7364FF',
                },
            },
        },
    },
    button: {
        design: {
            white: {
                'background-color': tokens.color.primary.seattle.c05,
            },
        },
        size: {
            xs: {
                'font-size': '14px',
                padding: '0 10px',
                height: '30px',
                'border-radius': '8px',
            },
        },
        gap: {
            xs: {
                'margin-right': '4px',
            },
        },
    },
};
